import { useEffect, useState } from "react";

const RevenueInfo = (props) => {
  const [activeEmiData, setActiveEmiData] = useState({});
  const activeEmiCardInfo = [
    {
      title: "# Active EMI Loans",
      count: activeEmiData?.totalActiveEMILoans || 0,
      amount: activeEmiData?.totalActiveEMILoanAmt || 0,
      icon: imagepaths.dollarCollectionIcon,
      path: "/app/loandetails?activetab=active&producttype=EMI",
    },

    {
      title: "# EMIs Received",
      count: activeEmiData?.currentMonthEMIPaidTillDate || 0,
      amount: activeEmiData?.currentMonthEMIPaidAmtTillDate || 0,
      icon: imagepaths.dollarBagIcon,
      path: "/app/loandetails?activetab=active&producttype=EMI&emiFilter=paid",
    },
    {
      title: "# EMIs Due This Month",
      count: activeEmiData?.currentMonthExpectedEMI || 0,
      amount: activeEmiData?.currentMonthExpectedEMIAmt || 0,
      icon: imagepaths.coinStackIcon,
      path: "/app/loandetails?activetab=active&producttype=EMI&emiFilter=expected",
    },
    {
      title: "# EMIs Over Due",
      count: activeEmiData?.currentMonthEMIOverdueTillDate || 0,
      amount: activeEmiData?.currentMonthEMIOverdueAmtTillDate || 0,
      icon: imagepaths.percentageRoundedIcon,
      path: "/app/loandetails?activetab=active&producttype=EMI&emiFilter=overdue",
    },
  ];
  // REVENUE INFO

  const getOverallSummaryYesterday = (query, params) => {
    let data = {
      ...query,
    };

    let payload = {};
    props.apis.apiGetStaticSummaryForYesterday(data, payload).then((res) => {
      setActiveEmiData(res);
    });
  };

  useEffect(() => {
    getOverallSummaryYesterday();
  }, []);

  props.$setNode({
    props,
    activeEmiData,
  });
  return (
    <>
      <div className="mb-4 dashboard_form_box">
        <div className="row pt-0 pt-md-4">
          {activeEmiCardInfo &&
            activeEmiCardInfo.map((revenue) => {
              return (
                <>
                  <div
                    className="col-xl-3 col-sm-6"
                    onClick={(...args) => navigate(revenue?.path)}
                  >
                    <div className="card dashboard_card application_card revenue_info_card">
                      <div className="border_bottom_line"></div>
                      <div className="card-body">
                        <div className="icon_container">
                          <p className="icon_title">{revenue?.title}</p>
                          <div className="icon">
                            <img src={revenue?.icon} alt="icon image" />
                          </div>
                        </div>
                        <div className="content">
                          <p className="count">{revenue?.count}</p>
                          <p className="card_label">
                            Amount :{" "}
                            <span className="primary-red ms-1">
                              {revenue?.amount?.cur()}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default constore(RevenueInfo);
